import { render, staticRenderFns } from "./GradeStepView.vue?vue&type=template&id=12d681df&scoped=true"
import script from "./GradeStepView.vue?vue&type=script&lang=js"
export * from "./GradeStepView.vue?vue&type=script&lang=js"
import style0 from "./GradeStepView.vue?vue&type=style&index=0&id=12d681df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d681df",
  null
  
)

export default component.exports